import { CommonModule } from '@angular/common';
import { Inject, NgModule, Optional } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonComponentsModule } from '@ddv/common-components';
import { ApiConfiguration, defaultApiConfiguration, hostAndPortForService, HttpModule } from '@ddv/http';
import { SocketModule } from '@ddv/socket';

import { NamedQuerySelectorComponent } from './components/named-query-selector/named-query-selector.component';
import {
    NamedQueriesService,
    cfbApiLocationToken,
    trebekApiLocationToken,
    replaceHostInMetadataAndQueryURLsToken,
} from './services/named-queries.service';

@NgModule({
    imports: [
        CommonComponentsModule,
        CommonModule,
        HttpModule,
        RouterModule,
        SocketModule,
    ],
    providers: [
        NamedQueriesService,
        {
            provide: replaceHostInMetadataAndQueryURLsToken,
            useFactory: (c: ApiConfiguration): boolean => c.replaceHostInMetadataAndQueryURLs,
            deps: [[new Inject('apiConfig'), new Optional()]],
        },
        {
            provide: trebekApiLocationToken,
            useFactory: (c: ApiConfiguration): string => {
                const config = c ?? defaultApiConfiguration;
                return `${window.location.protocol}//${hostAndPortForService(config.trebekApiLocation.hostAndPort, config.onPremApiHost)}`;
            },
            deps: [[new Inject('apiConfig'), new Optional()]],
        },
        {
            provide: cfbApiLocationToken,
            useFactory: (c: ApiConfiguration): string => {
                const config = c ?? defaultApiConfiguration;
                return `${window.location.protocol}//${hostAndPortForService(config.cfbApiLocation.hostAndPort, config.onPremApiHost)}`;
            },
            deps: [[new Inject('apiConfig'), new Optional()]],
        },
    ],
    declarations: [
        NamedQuerySelectorComponent,
    ],
    exports: [
        NamedQuerySelectorComponent,
    ],
})
export class NamedQueriesModule { }
